import { IPackageListingAppBaseText, defaultBaseText } from "../../classes/package-listing-text";

/**
 * Want to add more text? Go to custom/classes/calendar-text and add new properties there.
 */
interface IPackageListingCustomText {
}


let customText: IPackageListingCustomText = {
}

export type IPackageListingAppText = IPackageListingCustomText & IPackageListingAppBaseText;
export const defaultText: IPackageListingAppText = { ...defaultBaseText, ...customText };